export const getEvents = state => state.events.data || [];
